module.exports = __webpack_public_path__ + "static/img/check-sum.b3c2265.jpg";